import React, { useContext, useEffect, useState } from 'react'
import { EmpdContext, EmpdProvider } from '../../Context'
import Button from "../../Components/Button"
import  EditModal from '../../Components/EditModal'
import DashboardNavigationBar from '../Registered/Components/PatientDashboard/Components/DashboardNavigationBar'
import { TextField } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete';
import { createUseStyles } from "react-jss";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser"
import MsalLoadingComponent from "../../Components/Msal/MsalLoadlingComponent"
import NotAuthorized from "../../Components/NotAuthorized"
import { isProvider } from "../../utils"

interface Props {
    classes?: any,
}

interface OptionType {
	label: string;
	value: string;
}

const useStyles = createUseStyles({
  root: {
    backgroundColor: "aaaaaa",
    padding: "50px",
    flexBasis: "28%",
    borderRadius: "5px",
    "@media (max-width: 1240px)": {
      marginBottom: "30px",
    },
  },
  dashboardWrapper: {
    background: "#f8f8f8",
    height: "100%",
    padding: "50px 0px",
  },
  dashboardContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "top",
  },
  dashboardCard: {
    flexBasis: "75.5%",
  },
  icon: {
    width: 30,
    height: "auto",
    marginRight: 10,
  },
  announcementHeading: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});

const titleCase = (value:string) => {
	return value
		.toLowerCase()
		.split('_')
		.map((word:string) => {
			return word.charAt(0).toUpperCase() + word.slice(1)
		})
		.join(' ')
}

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const EditorPage = ({classes}: Props) => {

  const context = useMyContext()
  const { setEditDialogOpen, user, isLoading, fetchMessageContent, messagingContent } = context
  const [type, setType] = useState<string|undefined>(undefined)
  const [content, setContent] = useState<string|undefined>(undefined)
  const [header, setHeader] = useState<string|undefined>(undefined)
  const [showMessage, setShowMessage] = useState<boolean>(false)
  const [selectedValue, setSelectedValue] = useState<any|null>(null)

  const styles = useStyles()
  let options: OptionType[] = []

  useEffect(() => {
  	fetchMessageContent()
  }, [])

	if( messagingContent && messagingContent.length > 0 ) {
	  	options = messagingContent.map((contentObj:any) => {
			const type = Object.keys(contentObj)[0]
			return { label: titleCase(type), value: type }
		})
	}

  return (
  	<MsalAuthenticationTemplate
		interactionType={InteractionType.Redirect}
		errorComponent={NotAuthorized}
        loadingComponent={MsalLoadingComponent}
	>
  		<div>
			<DashboardNavigationBar />
		  	<div className={styles.root}>
				<EditModal type={type} header={header} content={content} setHeader={setHeader} showMessage={showMessage} setShowMessage={setShowMessage} setSelectedValue={setSelectedValue} />
				<div className='card-head'>
					{'Use this page to edit the messaging content on the patient and provider dashboards'}
					<div className='card-content'>
					<Autocomplete
						sx={{
                        	width: 500,
	                        "& .MuiOutlinedInput-root": {
    	                        color: "#002F6C",
        	                    // Class for the border around the input field
            	                "& .MuiOutlinedInput-notchedOutline": {
                	                borderColor: "#002F6C",
                    	            borderWidth: "2px",
                        	    },
	                        },
    	                    // Class for the label ofthe input field
        	                "& .MuiInputLabel-outlined": {
            	                color: "#002F6C",
                	        },
                    	}}
	                    onChange={(event: React.SyntheticEvent, value: any) => {
							if( value ) {
								const obj = messagingContent.find((element:any) => {
									return Object.keys(element)[0] === value.value
								})[value.value]
								setSelectedValue(value)
                	            setType(value.value)
                    	        setContent(obj.content)
                        	    if( obj.header !== undefined ) {
									setHeader(obj.header)
	                            }
								setShowMessage(obj.showMessage)
								setEditDialogOpen(true)
							}
    	              }}
        	          renderInput={(params) => <TextField {...params} label={'Content To Edit'} />}
            	      options={options}
					  value={selectedValue}
					/>
					</div>
				</div>
			</div>
		</div>
	</MsalAuthenticationTemplate>
  )
}

export default EditorPage;
